/**
 * Pages proposées pour le champ `page_accueil` des fonctions (Gestion → Fonctions).
 * À tenir aligné avec les <Route> sous Layout dans App.jsx.
 */
export const PAGE_ACCUEIL_OPTIONS = [
  { value: '/dashboard', label: 'Tableau de bord' },
  { value: '/fiches', label: 'Fiches' },
  { value: '/planning', label: 'Planning' },
  { value: '/planning-commercial', label: 'Planning Commercial' },
  { value: '/planning-hebdomadaire', label: 'Planning Hebdomadaire' },
  { value: '/planning-dep', label: 'Planning Dép' },
  { value: '/rdv-vue', label: 'Vue Rendez-vous' },
  { value: '/affectation-dep', label: 'Affectation par Département' },
  { value: '/affectation', label: 'Affectation' },
  { value: '/statistiques', label: 'Statistiques' },
  { value: '/statistiques-rdv', label: 'Statistiques RDV' },
  { value: '/statistiques-fiches', label: 'Statistiques Fiches' },
  { value: '/statistiques-v2', label: 'Statistiques V2' },
  { value: '/assistance-ia', label: 'Assistance IA' },
  { value: '/production-qualif', label: 'Production Qualif' },
  { value: '/kpi-qualification', label: 'KPI Qualification' },
  { value: '/kpis', label: 'KPIs' },
  { value: '/mes-indicateurs', label: 'Mes indicateurs' },
  { value: '/signatures', label: 'Signatures' },
  { value: '/suivi-telepro', label: 'Suivi Télépro' },
  { value: '/suivi-agents-qualif', label: 'Suivi Agents Qualif' },
  { value: '/suivi-agents', label: 'Suivi des Agents' },
  { value: '/controle-qualite', label: 'Contrôle Qualité' },
  { value: '/alertes', label: 'Alertes' },
  { value: '/remarques', label: 'Remarques' },
  { value: '/audit-rdv', label: 'Audit Rendez-vous' },
  { value: '/stats-agents-qualite', label: 'Stats Agents Qualité' },
  { value: '/compte-rendu', label: 'Compte Rendu' },
  { value: '/tracking', label: 'Tracking' },
  { value: '/compte-rendu-pending', label: 'Compte rendu — En attente' },
  { value: '/phase3', label: 'Phase 3' },
  { value: '/messages', label: 'Messages' },
  { value: '/decalages', label: 'Décalages' },
  { value: '/validation', label: 'Validation' },
  { value: '/mes-rappels', label: 'Mes rappels' },
  { value: '/mon-equipe', label: 'Mon équipe (utilisateurs)' },
  { value: '/rappels-bureau', label: 'Rappels Bureau' },
  { value: '/users', label: 'Utilisateurs' },
  { value: '/management', label: 'Gestion' },
  { value: '/system-messages', label: 'Messages Système' },
  { value: '/permissions', label: 'Permissions' },
  { value: '/import-masse', label: 'Import en Masse' },
  { value: '/demandes-insertion', label: "Demandes d'insertion" },
  { value: '/notifications', label: 'Notifications' },
  { value: '/mon-profil', label: 'Mon profil' },
];

export const PAGE_ACCUEIL_KNOWN_PATHS = new Set(PAGE_ACCUEIL_OPTIONS.map((o) => o.value));
